import { urlParams } from '@ctct/infrastructure-layer';

/**
 * Validates that a return URL is safe to redirect to.
 * Only allows HTTPS URLs on constantcontact.com domains.
 */
export const isValidReturnUrl = (returnUrl: string): boolean => {
  try {
    const url = new URL(returnUrl);

    if (url.protocol !== 'https:') {
      return false;
    }

    return /^(([a-zA-Z0-9-]+\.)*)?constantcontact\.com$/.test(url.hostname);
  } catch {
    return false;
  }
};

/**
 * Gets validated return URL from query params, or null if invalid/missing.
 */
export const getSingleBillReturnUrl = (): string | null => {
  const returnUrl = urlParams.getReturnUrl();

  if (returnUrl && isValidReturnUrl(returnUrl)) {
    return returnUrl;
  }

  return null;
};
